// extracted by mini-css-extract-plugin
export default {"text":"text--C6KNz"};